<template>
  <div id="footer">
    <div class="cell">
      <div class="infos">
          <div class="left">
              <dl>
                  <p class="title_name">友情链接</p>
              </dl>
              <dl>
                  <p class="link_name"><a target="_blank" href="http://www.igsnrr.ac.cn/">中国科学院地理科学与资源研究所</a></p>
                  <p class="link_name"><a  target="_blank" href="http://www.starmap.com.cn/">星球地图出版社</a></p>
              </dl>
              <dl>
                  <p class="link_name"><a  target="_blank" href="https://www.imagesky.com.cn/">苏州中科天启遥感科技有限公司</a></p>
                  <p class="link_name"><a  target="_blank" href="http://www.casic.com.cn/">中国航天科工集团有限公司</a></p>
              </dl>
              <dl>
                  <p class="link_name"><a  target="_blank" href="http://www.radi.cas.cn/">中国科学院遥感与数字地球研究所</a></p>
                  <p class="link_name"><a  target="_blank" href="http://www.doubleskyline.com/">中国道达天际科技有限公司</a></p>
              </dl>
              <dl>
                  <p class="link_name"><a  target="_blank" href="http://www.nrscc.gov.cn/">中华人民共和国科学技术部国家遥感中心</a></p>
                  <p class="link_name"><a  target="_blank" href="http://www.unistrong.com/Default.aspx">北京合众思壮科技股份有限公司</a></p>
              </dl>
          </div>
          <div class="mainstring"></div>
          <div class="right">
            <div class="header">联系方式</div>
            <div class="body">
                <div class="body_left">
                    <img src="../../assets/images/footer/footer_wchat.png" alt="二维码">
                </div>
                <div class="body_right">
                  <dl class="dis_name">
                      <div class="icon phone"></div>
                      <p class="dis_infos">电话：010-52861878</p>
                  </dl>
                  <dl class="dis_name">
                      <div class="icon email"></div>
                      <p class="dis_infos">邮箱：public@mapscloud.cn</p>
                  </dl>
                  <dl class="dis_name">
                      <div class="icon adress"></div>
                      <p class="dis_infos">地址：北京市海淀区花园北路14号66幢2层226号</p>
                  </dl>
                </div>
            </div>
          </div>
      </div>
      <div class="bottom">
          © 2018-07-02 mapscloud.cn 北京星球时空科技有限公司 京ICP备18034031号
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'HomeFooter',
  data:function(){
    return {

    }
  },
  methods:{

  }
}
</script>

<style scoped>
#footer{
  padding-bottom: 280px;
  background: #3d4147;
  height: 0px;
  z-index: 1;
}
#footer .cell{
  position: relative;
}
#footer .cell .infos{
  width: 1150px;
  height: 230px;
  margin: 0 auto;
}
#footer .cell .infos .left{
  width: 536px;
  height: 140px;
  margin-top: 44px;
  float: left;
  margin-left: 37px;
}
#footer .cell .infos .left dl{
  width: 100%;
  margin-bottom: 20px;
}
#footer .cell .infos .left dl .title_name{
  width: 50%;
  line-height: 12px;
  color: #babdc3;
  line-height: 12px;
}
#footer .cell .infos .left dl .link_name{
  width: 49%;
  text-align: left;
  display: inline-block;
  height: 12px;
}
#footer .cell .infos .left dl .link_name a{
  line-height: 12px;
  color: #6f7275;
  font-size: 12px;
}
#footer .cell .infos .mainstring{
  width: 1px;
  height: 140px;
  background: #2e3238;
  margin-top: 44px;
  float: left;
}
#footer .cell .infos .right{
  width: auto;
  margin-top: 40px;
  margin-left: 49px;
  float: left;
}
#footer .cell .infos .right .header{
  color: #ffffff;
  font-size: 18px;
  height: 18px;
}
#footer .cell .infos .right .body{
  margin-top: 19px;
}
#footer .cell .infos .right .body .body_left{
  display: inline-block;
  width: 110px;
  height: 100px;
}
#footer .cell .infos .right .body .body_left img{
  width: 100%;
  height: 100%;
}
#footer .cell .infos .right .body .body_right{
  display: inline-block;
  margin-left: 25px;
}
#footer .cell .infos .right .body .body_right .icon{
  width: 15px;
  height: 15px;
  float: left;
}
#footer .cell .infos .right .body .body_right .phone{
  background: url(../../assets/images/footer/icon_phone.png) 0px 0px no-repeat;
}
#footer .cell .infos .right .body .body_right .email{
  background: url(../../assets/images/footer/icon_email.png) 0px 0px no-repeat;
}
#footer .cell .infos .right .body .body_right .adress{
  background: url(../../assets/images/footer/icon_adress.png) 0px 0px no-repeat;
}

#footer .cell .infos .right .body .body_right .dis_infos{
  margin-left: 27px;
  text-align: left;
  line-height: 15px;
  font-size:12px;
  color: #ffffff;
}
#footer .cell .infos .right .body .body_right .dis_name{
  height: 15px;
  margin-bottom: 30px;
}
#footer .bottom{
  height: 50px;
  width: 100%;
  background:#2e3238;
  text-align:center;
  color: #76797b;
  line-height: 50px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/components/footer.vue